export default "__VITE_ASSET__CMHp4tI8__"